import { IS_DEVELOPMENT, ORG_API_TIMEOUT } from '~/modules/config';
import { userStore } from '~/modules/stores/userStore';
import { getCookie } from '~/modules/utilities/cookies';
import { HttpRequestConfig } from '~/modules/utilities/http';

type OrgRequestHttpConfig = HttpRequestConfig & Pick<Required<HttpRequestConfig>, 'headers' | 'timeout'>;

//this function is located here instead of directly in the http.ts class because this function uses client-side stuff
export function setupOrgRequestConfig({ includeAuth = true }: { includeAuth?: boolean } = {}): OrgRequestHttpConfig {
    const authHeader: HttpRequestConfig['headers'] = {};

    if (includeAuth) {
        //TODO we will expect the sid cookie to be present only when using Org Auth (old way).
        //TODO Therefore, this SID related code can be removed once we are permanently using OIDC Auth (new way)
        //TODO AND we no longer need the sid cookie to support legacy Get It Now (GIN) flows
        const sid = getCookie('sid');
        if (sid) {
            authHeader.Authorization = `Bearer ${sid}`;
        }
    }

    const httpConfig: OrgRequestHttpConfig = {
        headers: authHeader,
        timeout: ORG_API_TIMEOUT,
    };

    return httpConfig;
}

export function setupTMPrivateRequestConfig(): OrgRequestHttpConfig {
    const orgRequestConfig: OrgRequestHttpConfig = setupOrgRequestConfig();

    const userStoreState = userStore.getState();
    const tbidAccessToken = userStoreState.tbidProfile?.access_token || userStoreState.access_token;

    if (tbidAccessToken) {
        orgRequestConfig.headers = {
            ...orgRequestConfig.headers,
            'tbid-token': tbidAccessToken,
        };
    }

    if (IS_DEVELOPMENT) {
        const alternativeSid = getCookie('dev_sid');

        if (alternativeSid) {
            orgRequestConfig.headers.Authorization = `Bearer ${alternativeSid}`;
        }
    }

    return orgRequestConfig;
}
